import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: { id: 'Homepage contact', defaultMessage: 'Homepage contact' },
  adreca: { id: 'Address', defaultMessage: 'Address' },
  telefons: { id: 'Phones', defaultMessage: 'Phones' },
  email: { id: 'Email', defaultMessage: 'Email' },
  background: { id: 'Background image', defaultMessage: 'Background image' },
});

export const HomepageContactSchema = ({ intl }) => ({
  title: intl.formatMessage(messages.title),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['background', 'adreca', 'telefons', 'email'],
    },
  ],
  properties: {
    background: {
      title: intl.formatMessage(messages.background),
      widget: 'object_browser',
      mode: 'image',
      return: 'single',
      selectableTypes: ['Image'],
      initialPath: '/recursos',
      selectedItemAttrs: ['@type', 'title', 'image_field', 'image_scales'],
    },
    adreca: { title: intl.formatMessage(messages.adreca), widget: 'textarea' },
    telefons: {
      title: intl.formatMessage(messages.telefons),
      widget: 'textarea',
    },
    email: { title: intl.formatMessage(messages.email), widget: 'textarea' },
  },
  required: [],
});
